const verification_record = {
    not_found: 'Enregistrement de vérification introuvable.',
    permission_denied: 'Permission refusée, veuillez vous réauthentifier.',
    not_supported_for_google_one_tap: 'Cette API ne prend pas en charge Google One Tap.',
};
export default Object.freeze(verification_record);
